"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _appRulesResolver = require("@match/app-rules-resolver");

var _reactIntl = require("react-intl");

var _messages = require("../constants/messages");

var _TopNavMenuLayout = _interopRequireDefault(require("./layout/TopNavMenuLayout"));

var SUPPORTED_CULTURE_CODES = [_appRulesResolver.CULTURE_CODE.ENGLISH, _appRulesResolver.CULTURE_CODE.SPANISH_MEXICO, _appRulesResolver.CULTURE_CODE.JAPANESE, _appRulesResolver.CULTURE_CODE.KOREAN, _appRulesResolver.CULTURE_CODE.PORTUGUESE, _appRulesResolver.CULTURE_CODE.CHINESE_TRADITIONAL];

var getLocaleForCultureCode = function getLocaleForCultureCode(cultureCode) {
  if (!cultureCode) {
    // Default to english if no culture code is provided
    return _appRulesResolver.CULTURE_CODE.ENGLISH;
  } else if (!!cultureCode && SUPPORTED_CULTURE_CODES.includes(cultureCode)) {
    // Use exact match if it exists
    return cultureCode;
  } else {
    // Fall back to similar (i.e. es-MX for es-AR) if it exists, otherwise fall back to english
    var similarCultureCode = SUPPORTED_CULTURE_CODES.find(function (cc) {
      return cc.substring(0, 2) === cultureCode.substring(0, 2);
    });
    return similarCultureCode || _appRulesResolver.CULTURE_CODE.ENGLISH;
  }
};

function TopNavMenuContainer(props) {
  var countryCode = props.countryCode,
      cultureCode = props.cultureCode,
      _props$featureFlagOve = props.featureFlagOverrides,
      featureFlagOverrides = _props$featureFlagOve === void 0 ? {} : _props$featureFlagOve,
      siteCode = props.siteCode,
      urlCode = props.urlCode,
      siteName = props.siteName,
      layoutProps = (0, _objectWithoutProperties2.default)(props, ["countryCode", "cultureCode", "featureFlagOverrides", "siteCode", "urlCode", "siteName"]);
  if (!siteCode || !urlCode) throw new Error('urlCode and siteCode are required for react-top-nav-menu');
  var locale = (0, _react.useMemo)(function () {
    return getLocaleForCultureCode(cultureCode);
  }, [cultureCode]);
  var standardFeatureFlags = (0, _react.useMemo)(function () {
    return (0, _appRulesResolver.getFeatureFlags)({
      urlCode: urlCode,
      siteCode: siteCode,
      countryCode: countryCode
    });
  }, [countryCode, siteCode, urlCode]);
  var featureFlags = Object.assign({}, standardFeatureFlags, {}, featureFlagOverrides); // For SC10 (Stir), we need to only hide Power Ups
  // but still display

  var isStir = siteCode === _appRulesResolver.SITECODE.STIR;
  var hidePowerUpsOnStir = isStir && layoutProps.isSubscriber; // This conditionally hides the power up button for sites that use sub tiers instead of add ons (currently Latam),
  // so that it is only visible if the user is either a non-sub or both gold tier (canPurchaseReplyForFree) and non-comped (!isCompedUser)
  // CHECK LATAM IF YOU CHANGE THIS CONDITION

  var shouldShowPowerUpButton = !hidePowerUpsOnStir && (featureFlags[_appRulesResolver.FEATURE_FLAGS.ADD_ONS] || !layoutProps.isSubscriber || !layoutProps.isCompedUser && layoutProps.canPurchaseReplyForFree);
  return _react.default.createElement(_reactIntl.IntlProvider, {
    locale: locale,
    messages: _messages.messages[locale]
  }, _react.default.createElement(_TopNavMenuLayout.default, (0, _extends2.default)({
    featureFlags: featureFlags
  }, layoutProps, {
    shouldShowPowerUpButton: shouldShowPowerUpButton,
    siteCode: siteCode,
    siteName: siteName
  })));
}

var _default = TopNavMenuContainer;
exports.default = _default;